<div class="flex-col gap-4">
  <div class="flex-row gap-12 wrap w100">
    @if (articleInfos()) {
      <div class="flex-row gap-8 w100">
        <div class="flex-col h100 justify-center">
          @if (articleInfos().photo) {
            <vl-doc-local width="36px" height="36px" [docId]="articleInfos().photo" [readOnly]="true"/>
          } @else {
            <vl-just-logo
              [colorId]="articleInfos().id"
              [height]="'36px'"
              [simple]="true"
              [width]="'36px'"/>
          }
        </div>

        <ng-template #popover let-close="close">

          @if (this.navigation()) {
            <div class="border-8 up-4 container-background-reverse-alt p-12 flex-col gap-12 border-primary">
              <div class="flex-col w100">
                <div class="flex-row w100">
                  <mat-icon class="ml-auto" (click)="close?.()">close</mat-icon>
                </div>
                <div class="flex-col gap-4">
                <span class="on-background-reverse">
          @if (articleInfos()?.bio) {
            <vl-bio-logo/>
          }
                  {{ articleInfos().denomination }}</span>
                  <span class="on-background-reverse-alt body-2">{{ articleInfos().code }}</span>
                </div>
              </div>
              <div class="flex-row gap-12 justify-center">
                @if (articleInfos()?.withTraca) {
                  <vl-chips state="warn" size="small" cursor="default">{{ 'article_badges.traca' | trans }}</vl-chips>
                }
                @if (articleInfos()?.withPiedDeChaine) {
                  <vl-chips state="primary" size="small" cursor="default">{{ 'article_badges.pdc' | trans }}</vl-chips>
                }
                @if (articleInfos()?.withConsoTraca) {
                  <vl-chips state="warn" size="small" cursor="default">{{ 'article_badges.consos' | trans }}</vl-chips>
                }
                @if (!articleInfos()?.withConsoTraca && !articleInfos()?.withPiedDeChaine) {
                  <vl-chips state="secondary" size="small" cursor="default">{{ 'article_badges.auto' | trans }}</vl-chips>
                }
              </div>
              <vl-big-button (action)="this.onNavigate()" [text]="'article.goToArticle' | trans" icon="link"
                             color="accent"/>
              <vl-big-button (action)="onStats()" [text]="'data.stats' | trans" icon="query_stats"
                             color="accent"/>
              <vl-big-button class="w100" color="accent"
                             icon="123"
                             (action)="goToComptage()"
                             [text]="'lot.count' | trans"/>


              <vl-big-button class="w100"
                             icon="package_2"
                             (action)="onStock()"
                             [text]="'data.lots' | trans" color="accent"/>
            </div>
          }
        </ng-template>

        <div class="flex-row space-between basis-150"
             [ngClass]="{'cursor-pointer': navigation()}"
             [matTooltipDisabled]="!navigation()"
             [matTooltip]="'article.goToArticle' | trans"
             [closeOnClickOutside]="true"
             [popoverTrigger]="popover">
          <div class="flex-col">
            <span class="article-denomination on-background">@if (articleInfos()?.bio) {
              <vl-bio-logo size="small"/>
            }{{ articleInfos().denomination }}</span>
            @if (articleInfos()?.code) {
              <span class="article-code caption on-background-alt">{{ articleInfos().code }}</span>
            }
          </div>
        </div>

        <div class="flex-row gap-4 ml-auto">
          @if (showVersions()) {
            <div class="flex-container gap-4 w-36">
              @if (currentVersion()) {
                <div class="flex-row ml-auto">
                  <vl-chips [contentHeight]="true" size="small" cursor="default" state="valid">
                    <div class="flex-row gap-4">
                      <div class="flex-row align-center">
                        <span class="tiny">
                          v{{ currentVersion().version_nb }}
                        </span>
                      </div>
                      <mat-icon class="tiny-icon">check</mat-icon>
                    </div>
                  </vl-chips>
                </div>
              }
              @if (lastVersion() && (!currentVersion() || currentVersion().id !== lastVersion().id)) {
                <div class="flex-row ml-auto">
                  <vl-chips [contentHeight]="true" size="small" cursor='default' [state]="lastVersionState()">
                    <div class="flex-row gap-4">
                      <div class="flex-row align-center">
                        <span class="tiny">
                          v{{ lastVersion().version_nb }}
                        </span>
                      </div>
                      <mat-icon class="tiny-icon">edit</mat-icon>
                    </div>
                  </vl-chips>
                </div>
              }
            </div>
          }
          @if (showIcons()) {

            <div class="flex-col gap-4">
              @if (articleInfos()?.withTraca) {
                <vl-chips state="warn" cursor="default" size="small"><span class="tiny">{{ 'article_badges.traca' | trans }}</span></vl-chips>
              }
              @if (articleInfos()?.withPiedDeChaine) {
                <vl-chips state="primary" size="small" cursor="default"><span class="tiny">{{ 'article_badges.pdc' | trans }}</span></vl-chips>
              }
              @if (articleInfos()?.withConsoTraca) {
                <vl-chips state="secondary" cursor="default" size="small"><span class="tiny">{{ 'article_badges.consos' | trans }}</span></vl-chips>
              }
              @if (!articleInfos()?.withConsoTraca && !articleInfos()?.withPiedDeChaine) {
                <vl-chips state="secondary" cursor="default" size="small"><span class="tiny">{{ 'article_badges.auto' | trans }}</span></vl-chips>
              }
            </div>
          }
        </div>
      </div>


    }
  </div>
  @if (sem() && showVersionsWarn()) {
    @if (!currentVersion()) {
      <vl-chips state="warn" cursor="default">{{ 'article.missing_current_version' | trans }}</vl-chips>
    }
    @if (!sem().isActive) {
      <vl-chips state="enabled" cursor="default">{{ 'article.archived' | trans }}</vl-chips>
    }
  }
</div>
